import { saveAs } from 'file-saver'
import { useEffect, useState } from 'react'

import { useAxiosHttpClient } from '@/modules/shared/infra/axios-http-client.infra'
import { HttpStatusCode } from '@/modules/shared/protocols/http-client.protocol'
import { useOrderFormComponentStoreActions } from '../stores/order-form-component.store'
import { loadOrderPdfService, type TLoadOrderPdfService } from '../services/load-order-pdf.service'
import { orderFormDataComponentService, type TOrderDataComponentService } from '../services/order-form-data-component.service'


export const useOrderSearchData = () => {
  const [idLoadingRequestPdf, setIsLoadingRequestPdf] = useState(false)
  const { setCustomers } = useOrderFormComponentStoreActions
  const { axiosRequest: requestOrderPdf } = useAxiosHttpClient({
    sendRequest: loadOrderPdfService,
  })

  const { axiosRequest: requestClientToReplicate } = useAxiosHttpClient({
    sendRequest: orderFormDataComponentService,
  })

  const handleSubmitOrderPdf = async ({ payload }: TLoadOrderPdfService) => {
    return await requestOrderPdf.mutateAsync({ payload })
  }

  const handleSubmitSearchClientToOrderReplicate = ({
    payload,
  }: TOrderDataComponentService) => {
    requestClientToReplicate.mutate({
      payload,
      showInfo: true,
    })
  }

  useEffect(() => {
    if (requestOrderPdf.isSuccess) {
      setIsLoadingRequestPdf(true)
      if (requestOrderPdf.data.status === HttpStatusCode.OK) {
        if (requestOrderPdf.data.body.includes('https')) {
          const xhr = new XMLHttpRequest()
          xhr.open('GET', requestOrderPdf.data.body, true)
          xhr.responseType = 'blob'
          xhr.onload = () => {
            const blob = xhr.response
            saveAs(
              blob,
              requestOrderPdf.data.message.toUpperCase() || 'download.pdf',
            )
          }
          xhr.send()

          return
        }
        const blob = b64toBlob(requestOrderPdf.data.body, 'application/pdf')
        const fileName =
          requestOrderPdf.data.message.toUpperCase() || 'download.pdf'
        saveAs(blob, fileName)
        setIsLoadingRequestPdf(false)
      }

      // Função para converter base64 para Blob
      function b64toBlob(b64Data, contentType, sliceSize = 512) {
        const byteCharacters = atob(b64Data)
        const byteArrays = []

        for (
          let offset = 0;
          offset < byteCharacters.length;
          offset += sliceSize
        ) {
          const slice = byteCharacters.slice(offset, offset + sliceSize)
          const byteNumbers = new Array(slice.length)
          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i)
          }
          const byteArray = new Uint8Array(byteNumbers)
          byteArrays.push(byteArray)
        }

        return new Blob(byteArrays, {
          type: contentType,
        })
      }
    }
  }, [requestOrderPdf.isLoading])

  useEffect(() => {
    if (requestClientToReplicate.isSuccess) {
      if (requestClientToReplicate.data.status === HttpStatusCode.OK) {
        setCustomers(JSON.parse(requestClientToReplicate.data.body))
      }
    }
  }, [requestClientToReplicate.isLoading])

  return {
    state: {
			isLoadingRequestClientToReplicate: requestClientToReplicate.isLoading,
      isLoadingRequestOrderPdf:
        requestOrderPdf.isLoading || idLoadingRequestPdf,
      isSuccessRequestOrderPdf: requestOrderPdf.isSuccess,
    },
    action: {
      onSubmitOrderPdf: handleSubmitOrderPdf,
      onSubmitSearchClientToOrderReplicate:
        handleSubmitSearchClientToOrderReplicate,
    },
  }
}
